import { createSlice } from "@reduxjs/toolkit";
import {
  getSessionMetadata,
  getSessionQuestions,
} from "../actions/fluxoNSimilar";

interface MetadataState {
  sessionMetadata: any | null;
  sessionQuestions: any | null;
  status: "idle" | "loading" | "ready" | "error";
  error: unknown | null;
  httpStatus: number | null;
  messageStatus: any;
}

const initialState: MetadataState = {
  sessionMetadata: null,
  sessionQuestions: null,
  status: "idle",
  error: null,
  httpStatus: null,
  messageStatus: null,
};
const sessionMetadataSlice = createSlice({
  name: "sessionMetadata",
  initialState,
  reducers: {
    resetClear(state) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSessionMetadata.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getSessionMetadata.rejected, (state, action) => {
        state.status = "error";
        state.sessionMetadata = null;
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getSessionMetadata.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionMetadata = action.payload;
        state.error = null;
        state.httpStatus = 200;
      })
      .addCase(getSessionQuestions.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getSessionQuestions.rejected, (state, action) => {
        state.status = "error";
        state.sessionQuestions = null;
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getSessionQuestions.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionQuestions = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      });
  },
});

export const { resetClear } = sessionMetadataSlice.actions;
export default sessionMetadataSlice.reducer;
